<script setup>
import { useNotifier } from '@daysmart/daysmart-vue-components/composables'
import { watch } from 'vue'
import { useSessionData } from '~/core/composables/useSessionData'

const { t } = useI18n()
const { locale } = useLocale()
const { sessionData } = useSessionData()
const notify = useNotifier()

const localeValue = ref(locale.value)

const refreshOnLocaleChange = sessionData?.refreshOnLocaleChange

const isDisabled = computed(() => {
  return !localeValue.value || localeValue.value === locale.value
})

const localeOptions = [
  {
    label: 'English (UK)',
    value: 'en-gb',
  },
  {
    label: 'English (US)',
    value: 'en-us',
  },
  {
    label: 'Français',
    value: 'fr',
  },
  {
    label: 'Deutsch',
    value: 'de',
  },
  {
    label: 'Español',
    value: 'es',
  },
]

function saveLocale() {
  locale.value = localeValue.value
  const selectedLocale = localeOptions.find(option => option.value === locale.value)
  nextTick(() => {
    notify.emit({
      type: 'success',
      title: t('Success'),
      content: `${t('Locale changed to { locale }', { locale: selectedLocale.label })}`,
    })
  })
  if (refreshOnLocaleChange)
    window.location.reload()
}

watch(locale, () => {
  localeValue.value = locale.value
})
</script>

<template>
  <div class="locale-switcher mb-8 flex flex-row items-center">
    <div class="mr-4 w-40">
      <DSListboxInput
        v-model="localeValue"
        :options="localeOptions"
        :deselect="false"
      />
    </div>
    <button
      class="btn-md uppercase btn-outline-white"
      :disabled="isDisabled"
      @click="saveLocale"
    >
      {{ t('Save') }}
    </button>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Save": "Save",
    "Success": "Success!",
    "Locale changed to { locale }": "Locale changed to { locale }"
  },
  "fr": {
    "Save": "Enregistrer",
    "Success": "Succès!",
    "Locale changed to { locale }": "Région définie sur { locale }"
  },
  "de": {
    "Save": "Speichern",
    "Success": "Erfolg!",
    "Locale changed to { locale }": "Gebietsschema geändert in { locale }"
  },
  "es": {
    "Save": "Guardar",
    "Success": "Operación realizada correctamente",
    "Locale changed to { locale }": "La región se ha cambiado a { Locale }"
  }
}
</i18n>
